import { createContext, useContext, useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import db from "../firebase/firebaseConfig"; 

import defaultLogo from "../assets/Digitalcoreweb Gradient Tech Logo.png";

const LocalContext = createContext();

export const LocalProvider = ({ children }) => {
  const [showCallModal, setShowCallModal] = useState(false);
  const [currentTFN, setCurrentTFN] = useState({
    intlFormat: "",
    localFormat: "",
    popup: false,
  });
  const [popupEnabled, setPopupEnabled] = useState(false);
  const [webinfo, setwebinfo] = useState({
    name: "Digitalcoreweb",
    phone: "",
    phonecall: "",
    email: "contact@digitalcoreweb.com",
    address: "India",
    logo: defaultLogo,
    logowhite: defaultLogo,
  });

  useEffect(() => {
    const fetchTFN = async () => {
      try {
        const docRef = doc(db, "siteNumbers", "digitalcoreweb.com");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const popupValue = Boolean(data.popup);
          setCurrentTFN({
            intlFormat: data.numberIntl || "",
            localFormat: data.numberLocal || "",
            popup: popupValue,
          });
          setPopupEnabled(popupValue);
        } else {
          setCurrentTFN({ intlFormat: "", localFormat: "", popup: false });
          setPopupEnabled(false);
        }
      } catch (error) {
        console.error("Error fetching TFN: ", error);
        setCurrentTFN({ intlFormat: "", localFormat: "", popup: false });
        setPopupEnabled(false);
      }
    };

    fetchTFN();
  }, []);

  useEffect(() => {
    setwebinfo((prevWebinfo) => ({
      ...prevWebinfo,
      phone: currentTFN.localFormat,
      phonecall: currentTFN.intlFormat,
      popup: currentTFN.popup,
    }));
  }, [currentTFN]);

  return (
    <LocalContext.Provider
      value={{
        webinfo,
        setwebinfo,
        showCallModal,
        setShowCallModal,
        popupEnabled,
        setPopupEnabled,
      }}
    >
      {children}
    </LocalContext.Provider>
  );
};

export const useLocalContext = () => useContext(LocalContext);
